var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"home",attrs:{"role":"main"}},[(!_vm.$store.state.managerDesktop)?_c('div',{staticClass:"main__header"},[_c('div',{staticClass:"main__header__item left"}),_c('div',{staticClass:"main__header__item"},[_c('h1',[_vm._v(_vm._s(_vm.title))])]),_c('div',{staticClass:"main__header__item right"},[(_vm.$store.state.me.role === 'partner')?_c('div',{staticClass:"small-buttons"},[_c('a',{staticClass:"tbl__setting",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.switchColumnModal.apply(null, arguments)}}},[_c('SettingsIcon')],1)]):_vm._e()])]):_vm._e(),(!['debtcontrol', 'partner', 'agent'].includes(_vm.$store.state.me.role) && !_vm.$store.state.managerDesktop)?_c('div',{ref:"headerWrapper",staticClass:"main__header main__header--secondary"},[_c('div',{ref:"toperLeft",staticClass:"toper__item left"},[_c('div',{staticClass:"tbl__filter__item"},[_c('VSelectQuery',{attrs:{"placeholder":"Сотрудник","key-value":"user_id","entity-name":"allUsers","select-width":"100%","disabled-select":!_vm.filterDropName.length,"entity-getter":function () { return _vm.filterDropName; }},on:{"input":_vm.onUserChange}})],1),_c('div',{staticClass:"tbl__filter__item"},[_c('VSelectQuery',{attrs:{"placeholder":"Подразделение","key-value":"id","select-width":"100%","disabled-select":!_vm.filterDropName.length,"entity-getter":function () { return _vm.extendedGroup; }},on:{"input":_vm.onGroupChange}})],1)]),_c('div',{staticClass:"toper__item",class:{ 'disabled-element' : !_vm.filterDropName.length }},[_c('div',{staticClass:"button-group"},[_c('button',{class:{ active: _vm.$store.state.data.trades.sort2 === 'today' },attrs:{"type":"button"},on:{"click":function($event){return _vm.setSortType('today')}}},[_c('span',[_vm._v("Сегодня")])]),_c('button',{class:{ active: _vm.$store.state.data.trades.sort2 === 'tomorrow' },attrs:{"type":"button"},on:{"click":function($event){return _vm.setSortType('tomorrow')}}},[_c('span',[_vm._v("Вчера")])]),_c('button',{class:{ active: _vm.$store.state.data.trades.sort2 === 'week' },attrs:{"type":"button"},on:{"click":function($event){return _vm.setSortType('week')}}},[_c('span',[_vm._v("Неделя")])]),_c('button',{class:{ active: _vm.$store.state.data.trades.sort2 === 'month' },attrs:{"type":"button"},on:{"click":function($event){return _vm.setSortType('month')}}},[_c('span',[_vm._v("Месяц")])]),_c('button',{directives:[{name:"click-outside",rawName:"v-click-outside",value:(_vm.vcoConfig),expression:"vcoConfig"}],ref:"buttonPeriod",staticClass:"widgets__table__field",class:{ active: _vm.$store.state.data.trades.sort2 === 'period' && _vm.$store.state.data.trades.sortDate },attrs:{"type":"button"},on:{"click":function($event){_vm.openPeriod = true}}},[_c('i',[_c('CalendarIcon')],1),_c('span',[_vm._v("Период")]),_c('b',{directives:[{name:"show",rawName:"v-show",value:(_vm.openPeriod),expression:"openPeriod"}],staticClass:"date-picker"},[_c('date-picker',{ref:"pickerPeriod",attrs:{"inline":"","range":""},model:{value:(_vm.$store.state.data.trades.sortDate),callback:function ($$v) {_vm.$set(_vm.$store.state.data.trades, "sortDate", $$v)},expression:"$store.state.data.trades.sortDate"}})],1)])])]),_c('div',{ref:"toperRight",staticClass:"toper__item right"},[_c('div',{staticClass:"small-buttons"},[_c('a',{staticClass:"tbl__setting",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.switchColumnModal.apply(null, arguments)}}},[_c('SettingsIcon')],1),_c('a',{staticClass:"btn btn--small btn--white",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.forceRerender.apply(null, arguments)}}},[_c('i',[_c('RefreshIcon')],1)])])])]):_vm._e(),_c('div',{staticClass:"main__content"},[(_vm.$apollo.loading && _vm.$store.state.me.role !== 'debtcontrol' && !_vm.$store.state.managerDesktop)?_c('div',{staticClass:"widgets"},_vm._l((Array(20).fill(0)),function(_,index){return _c('SplitWidget',{key:index,attrs:{"fields":{
            class: 'sceleton',
            items: [
              {
                class: 'text-orange',
                title: ' '
              }
            ]
          }}})}),1):_vm._e(),(_vm.$store.state.managerDesktop)?_c('div',[_c('ManagerDesktop')],1):(_vm.$store.state.me.role === 'debtcontrol')?_c('div',[_c('OsDesktop')],1):(!_vm.$apollo.loading && _vm.$store.state.me.role !== 'partner')?_c('div',{staticClass:"widgets"},_vm._l((_vm.widgetList),function(widget,index){return _c(widget.wType,{key:index,tag:"component",attrs:{"fields":widget.fields,"filter":_vm.filter,"isProtected":widget.isProtected}})}),1):(!_vm.$apollo.loading && _vm.$store.state.me.role === 'partner')?_c('div',{staticClass:"widgets--client"},_vm._l((_vm.widgetList),function(widget,index){return _c(widget.wType,{key:index,tag:"component",attrs:{"fields":widget.fields,"filter":_vm.filter}})}),1):(_vm.$store.state.me.role === 'qwadmin')?_c('div',{staticClass:"widgets"},[_c('SplitPercentWidget',{attrs:{"fields":{
          class: 'h-1-4',
          items: [
            {
              class: 'text-orange',
              title: 'Исходящие звонки',
              number: '52%'
            },
            {
              class: 'text-orange',
              title: 'Выполнено',
              number: '34/60'
            } ]
        }}}),_c('StandartWidget',{attrs:{"fields":{
          class: '',
          title: 'Всего новых заявок',
          content: '',
          number: '148',
          link: {
            link: '',
            outside: false
          }
        }}}),_c('StandartWidget',{attrs:{"fields":{
          class: '',
          title: 'Переданные заявки',
          content: '',
          number: '38',
          link: {
            link: 'https://mail.ru',
            outside: true
          }
        }}}),_c('StandartWidget',{attrs:{"fields":{
          class: 'text-orange',
          title: 'Доля звонков в заявках',
          content: '',
          number: '49%',
          link: {
            link: '',
            outside: false
          }
        }}}),_c('StandartWidget',{attrs:{"fields":{
          class: 'text-red',
          title: 'Отказ СБ',
          content: '',
          number: '13%',
          link: {
            link: '',
            outside: false
          }
        }}}),_c('SplitWidget',{attrs:{"fields":{
          class: '',
          items: [
            {
              class: 'text-orange',
              title: 'Заведенные проекты',
              number: '25'
            },
            {
              class: 'text-blue',
              title: 'Одобрено',
              number: '12'
            } ]
        }}}),_c('TwiceWidget',{attrs:{"fields":{
          class: 'text-green',
          title: 'Выдано',
          content: '15 проектов',
          number: '38 080 000 ₽'
        }}}),_c('TwiceFillWidget',{attrs:{"fields":{
          class: 'text-green',
          title: 'Заработок',
          number: '47 320 ₽',
          fill_text: 'До повыш. коэф.'
        }}}),_c('FillWidget',{attrs:{"fields":{
          class: 'status-fill-50',
          items: [
            {
              title: 'План',
              content: '68 000 000 ₽'
            },
            {
              title: 'Выполнено',
              content: '56 %'
            },
            {
              title: 'Остаток',
              content: '29 920 000 ₽'
            }
          ]
        }}}),_c('CheckWidget',{attrs:{"fields":{
          class: 'w-2-4',
          title: 'Средний чек',
          items: [
            {
              title: 'Июнь 2019',
              content: '3 402 000₽'
            },
            {
              title: 'Июнь 2020',
              content: '2 393 000₽'
            }
          ],
          graph: '-1,2%'
        }}}),_c('StandartWidget',{attrs:{"fields":{
          class: '',
          title: 'Ушли к конкурентам',
          content: '',
          number: '30%',
          link: {
            link: '',
            outside: false
          }
        }}})],1):_vm._e(),(_vm.$store.state.me.role === 'partner')?_c('div',{staticClass:"banner"},[_c('a',{attrs:{"href":"https://www.bankofkazan.ru/business/business-credits/?utm_source=leasing-trade&utm_medium=banner&utm_campaign=credit-ul","target":"_blank"}},[(this.sizeToggle > 900)?_c('label',[_c('HochuCredit1800')],1):_c('label',[_c('HochuCredit988')],1)])]):_vm._e()])])}
var staticRenderFns = []

export { render, staticRenderFns }